import {createBrowserRouter} from "react-router-dom";
import Construction from "../screens/construction/Construction";

const navigation = createBrowserRouter([
    {
        path: "/",
        element: <Construction/>
    }
])
export default navigation;